import {
  utils,
} from '@ama-sdk/core';
import {
  RegulatoryDetail,
  RegulatoryDetailsCategoryRequirement,
  RegulatoryDetailsReplyData,
} from '@dapi/sdk';
import {
  combineRegulatoryDetails,
  combineRegulatoryDetailsCategoryRequirements,
  combineRegulatoryDetailsRequirements,
  createRegulatoryDetailsReplyData,
  RegulatoryDetailRepository,
  RegulatoryDetailsCategoryRequirementRepository,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  travelers,
} from './journey-logic';

let missingDetails: RegulatoryDetailsCategoryRequirement[] = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        canBeDeclined: false,
        requiredDetailsFields: ['gender', 'birthDate', 'birthPlace', 'nationalityCountryCode', 'countryOfResidence']
      }
    ]).items
  },
  RegulatoryDetailsCategoryRequirementRepository.MISSING_TSA
]).items;

let storedDetails: RegulatoryDetail[] = [RegulatoryDetailRepository.STORED_TSA];

export const regulatories: RegulatoryDetailsReplyData[] = [];

/**
 *
 */
function addRegulatory() {
  regulatories.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatories.at(-1),
        storedDetails,
        missingDetails
      }
    })
  );
}

addRegulatory();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'FRA'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['gender', 'birthDate', 'birthPlace', 'countryOfResidence']
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'FRA',
    countryOfResidenceCode: 'FRA'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['gender', 'birthDate', 'birthPlace']
    }]).items
  },
  {
    isOptional: false,
    detailsCategory: 'identityDocument'
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthDate: travelers[1].dateOfBirth,
      gender: 'female',
      birthPlace: 'Nice'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      detailsType: 'document',
      regulatoryType: 'passport'
    }, {
      detailsType: 'document',
      regulatoryType: 'identityCard'
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'FRA',
      countryOfResidenceCode: 'FRA',
      birthDate: travelers[1].dateOfBirth,
      gender: 'female',
      birthPlace: 'Nice'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'FR',
      nationalityCode: 'FRA',
      name: travelers[1].names[0],
      number: '1234567890'
    }
  }
]).items;

missingDetails = [];

addRegulatory();

export const [getRegulatoryDetails, ...addRegulatoryDetails] = regulatories;
